<div *appIsDesktop>
  @if (invoiceFooterResult) {
    <div id="invoiceFooter" class="header-container">
      <ds-divider></ds-divider>
      <!-- First Subsection -->
      <div id="firstSubSection" class="first-subSection">
        <div id="firstRow" class="header-row">
          <!-- Terms Payment -->
          <div id="invoice_termsPayment">
            <typography variant="mat-caption-1" weight="regular" id="termsPaymentLabel" class="info-label">{{ appStrings.invoice_termsPayment }}</typography>
            <typography variant="mat-body-2" weight="bold" id="termsPaymentValue">{{ invoiceFooterResult.termsOfPayment }}</typography>
          </div>
          <!-- Payment Due -->
          <div id="invoice_paymentDue">
            <typography variant="mat-caption-1" weight="regular" id="paymentDueLabel" class="info-label">{{ appStrings.invoice_paymentDue }}</typography>
            @if (invoiceFooterResult.paymentDueOn) {
              <typography variant="mat-body-2" weight="bold" id="paymentDueValue">
              {{ invoiceFooterResult.paymentDueOn | date: dateFormat }}</typography>
            } @else {
              <typography variant="mat-body-2" weight="bold">-</typography>
            }
          </div>
          <!-- Carrier -->
          <div id="invoice_carrier">
            <typography variant="mat-caption-1" weight="regular" id="carrierLabel" class="info-label">{{ appStrings.invoice_carrier }}</typography>
            <typography variant="mat-body-2" weight="bold" id="carrierValue">{{ invoiceFooterResult.carrier }}</typography>
          </div>
          <div id="footerSpace_0">
            <typography class="info-label">&nbsp;</typography>
          </div>
        </div>
        <!-- Remit Section -->
        @if (!isAustralia) {
          <div id="invoice_remit" class="header-row">
            <!-- Remit To -->
            <div id="remitTo">
              <typography variant="mat-caption-1" weight="regular" id="remitToLabel" class="info-label">{{ appStrings.invoice_remit }}</typography>
              <typography variant="mat-body-2" weight="bold" id="remitToValue">
                {{ formatRemitTo([
                invoiceFooterResult.remitToName,
                invoiceFooterResult.remitToPhone,
                invoiceFooterResult.remitToAddress,
                formatRemitTo([invoiceFooterResult.remitToCity,
                invoiceFooterResult.remitToState,
                invoiceFooterResult.remitToZipCode], ', ')
                ]) }}
              </typography>
            </div>
          </div>
        } @else {
          <div id="remitRowAus" class="header-row">
            <!-- Remit To (Australia) -->
            <div id="remitToAus">
              <typography variant="mat-caption-1" weight="regular" id="remitToAusLabel" class="info-label">{{ appStrings.invoice_remit }}</typography>
              <typography variant="mat-body-2" weight="bold" id="remitToAusValue">
                {{ formatRemitTo([
                invoiceFooterResult.remitToName,
                invoiceFooterResult.remitToDepositPayments,
                invoiceFooterResult.remitToBank,
                invoiceFooterResult.remitToBsb,
                invoiceFooterResult.remitToAcc,
                invoiceFooterResult.remitToSwift
                ]) }}
              </typography>
            </div>
          </div>
        }
      </div>
      <ds-divider></ds-divider>
      <!-- Tax Summary Subsection -->
      @if (showTaxSummary) {
        <div id="secondSubSection" class="second-subSection">
          <div class="subSection-title">
            <typography id="taxSummary" variant="mat-body-1" weight="bold">
              Tax Summary
            </typography>
          </div>
          <div id="firstRowSecondSub" class="header-row">
            <!-- State Tax -->
            <div id="invoice_stateTax">
              <typography variant="mat-caption-1" weight="regular" id="stateTaxLabel" class="info-label">{{ appStrings.invoice_stateTax }}</typography>
              <typography variant="mat-body-2" weight="bold" id="stateTaxValue">{{ invoiceFooterResult.pstTax | currency: currencySymbol }}</typography>
            </div>
            <!-- District Tax -->
            @if (!countriesWithoutLocalAndDistrictTaxes[countryCode]) {
              <div id="invoice_districtTax">
                <typography variant="mat-caption-1" weight="regular" id="districtTaxLabel" class="info-label">{{ appStrings.invoice_districtTax }}</typography>
                <typography variant="mat-body-2" weight="bold" id="districtTaxValue">{{ invoiceFooterResult.districtTax | currency: currencySymbol }}</typography>
              </div>
            }
            <!-- Local Tax -->
            @if (!countriesWithoutLocalAndDistrictTaxes[countryCode]) {
              <div id="invoice_localTax">
                <typography variant="mat-caption-1" weight="regular" id="localTaxLabel" class="info-label">{{ appStrings.invoice_localTax }}</typography>
                <typography variant="mat-body-2" weight="bold" id="localTaxValue">{{ invoiceFooterResult.localTax | currency: currencySymbol }}</typography>
              </div>
            }
            <!-- County Tax -->
            <div id="invoice_county">
              <typography variant="mat-caption-1" weight="regular" id="countyLabel" class="info-label">{{ appStrings.invoice_county }}</typography>
              <typography variant="mat-body-2" weight="bold" id="countyValue">{{ invoiceFooterResult.gstTax | currency: currencySymbol }}</typography>
            </div>
          </div>
        </div>
        <ds-divider></ds-divider>
      }
      <!-- Totals Subsection -->
      <div id="thirdSubSection" class="second-subSection">
        <div class="subSection-title">
          <typography id="totals" variant="mat-body-1" weight="bold">
            Totals
          </typography>
        </div>
        <div id="firstRowThirdSub" class="header-row">
          <!-- Total Net -->
          <div id="invoice_totalNet">
            <typography variant="mat-caption-1" weight="regular" id="totalNetLabel" class="info-label">{{ appStrings.invoice_totalNet }}</typography>
            <typography variant="mat-body-2" weight="bold" id="totalNetValue">{{ invoiceFooterResult.totalNet | currency: currencySymbol }}</typography>
          </div>
          <!-- Total Shipping & Handling -->
          <div id="invoice_totalShippingHandling">
            <typography variant="mat-caption-1" weight="regular" id="totalShippingHandlingLabel" class="info-label">{{ appStrings.invoice_totalShippingHandling }}</typography>
            <typography variant="mat-body-2" weight="bold" id="totalShippingHandlingValue">{{ invoiceFooterResult.totalShippingAndHandling | currency: currencySymbol }}</typography>
          </div>
          <!-- Total Taxes -->
          <div id="invoice_totalTaxes">
            <typography variant="mat-caption-1" weight="regular" id="totalTaxesLabel" class="info-label">{{ appStrings.invoice_totalTaxes }}</typography>
            <typography variant="mat-body-2" weight="bold" id="totalTaxesValue">{{ invoiceFooterResult.totalTaxes | currency: currencySymbol }}</typography>
          </div>
          <!-- Total Amount -->
          <div id="invoice_totalAmount">
            <typography variant="mat-caption-1" weight="regular" id="totalAmountLabel" class="info-label">{{ appStrings.invoice_totalAmount }}</typography>
            <typography variant="mat-body-2" weight="bold" id="grandTotal">{{ invoiceFooterResult.totalAmount | currency: currencySymbol }}</typography>
          </div>
        </div>
      </div>
    </div>
  }
</div>

<div *appIsMobile>
  @if (invoiceFooterResult) {
    <div id="invoiceFooter" class="header-container">
      <ds-divider></ds-divider>
      <!-- First Subsection -->
      <div id="firstSubSection" class="first-subSection">
        <div id="firstRow" class="container-rows">
          <!-- Terms Payment -->
          <div id="invoice_termsPayment">
            <typography variant="mat-caption-1" weight="regular" id="termsPaymentLabel" class="info-label">{{ appStrings.invoice_termsPayment }}</typography>
            <typography variant="mat-body-2" weight="bold" id="termsPaymentValue">{{ invoiceFooterResult.termsOfPayment }}</typography>
          </div>
          <!-- Payment Due -->
          <div id="invoice_paymentDue">
            <typography variant="mat-caption-1" weight="regular" id="paymentDueLabel" class="info-label">{{ appStrings.invoice_paymentDue }}</typography>
            @if (invoiceFooterResult.paymentDueOn) {
              <typography variant="mat-body-2" weight="bold" id="paymentDueValue">
              {{ invoiceFooterResult.paymentDueOn | date: dateFormat }}</typography>
            } @else {
              <typography variant="mat-body-2" weight="bold">-</typography>
            }
          </div>
          <!-- Carrier -->
          <div id="invoice_carrier">
            <typography variant="mat-caption-1" weight="regular" id="carrierLabel" class="info-label">{{ appStrings.invoice_carrier }}</typography>
            <typography variant="mat-body-2" weight="bold" id="carrierValue">{{ invoiceFooterResult.carrier }}</typography>
          </div>
          <div id="footerSpace_0">
            <typography class="info-label">&nbsp;</typography>
          </div>
        </div>
        <!-- Remit Section -->
        @if (!isAustralia) {
          <div id="invoice_remit" class="header-row">
            <!-- Remit To -->
            <div id="remitTo">
              <typography variant="mat-caption-1" weight="regular" id="remitToLabel" class="info-label">{{ appStrings.invoice_remit }}</typography>
              <typography variant="mat-body-2" weight="bold" id="remitToValue">
                {{ formatRemitTo([
                invoiceFooterResult.remitToName,
                invoiceFooterResult.remitToPhone,
                invoiceFooterResult.remitToAddress,
                formatRemitTo([invoiceFooterResult.remitToCity,
                invoiceFooterResult.remitToState,
                invoiceFooterResult.remitToZipCode], ', ')
                ]) }}
              </typography>
            </div>
          </div>
        } @else {
          <div id="remitRowAus" class="header-row">
            <!-- Remit To (Australia) -->
            <div id="remitToAus">
              <typography variant="mat-caption-1" weight="regular" id="remitToAusLabel" class="info-label">{{ appStrings.invoice_remit }}</typography>
              <typography variant="mat-body-2" weight="bold" id="remitToAusValue">
                {{ formatRemitTo([
                invoiceFooterResult.remitToName,
                invoiceFooterResult.remitToDepositPayments,
                invoiceFooterResult.remitToBank,
                invoiceFooterResult.remitToBsb,
                invoiceFooterResult.remitToAcc,
                invoiceFooterResult.remitToSwift
                ]) }}
              </typography>
            </div>
          </div>
        }
      </div>
      <ds-divider></ds-divider>
      <!-- Tax Summary Subsection -->
      @if (showTaxSummary) {
        <div id="secondSubSection" class="second-subSection">
          <div class="subSection-title">
            <typography id="taxSummary" variant="mat-body-1" weight="bold">
              Tax Summary
            </typography>
          </div>
          <div id="firstRowSecondSub" class="header-row">
            <!-- State Tax -->
            <div id="invoice_stateTax">
              <typography variant="mat-caption-1" weight="regular" id="stateTaxLabel" class="info-label">{{ appStrings.invoice_stateTax }}</typography>
              <typography variant="mat-body-2" weight="bold" id="stateTaxValue">{{ invoiceFooterResult.pstTax | currency: currencySymbol }}</typography>
            </div>
            <!-- District Tax -->
            @if (!countriesWithoutLocalAndDistrictTaxes[countryCode]) {
              <div id="invoice_districtTax">
                <typography variant="mat-caption-1" weight="regular" id="districtTaxLabel" class="info-label">{{ appStrings.invoice_districtTax }}</typography>
                <typography variant="mat-body-2" weight="bold" id="districtTaxValue">{{ invoiceFooterResult.districtTax | currency: currencySymbol }}</typography>
              </div>
            }
          </div>
          <div id="secondRowSecondSub" class="header-row">
            <!-- Local Tax -->
            @if (!countriesWithoutLocalAndDistrictTaxes[countryCode]) {
              <div id="invoice_localTax">
                <typography variant="mat-caption-1" weight="regular" id="localTaxLabel" class="info-label">{{ appStrings.invoice_localTax }}</typography>
                <typography variant="mat-body-2" weight="bold" id="localTaxValue">{{ invoiceFooterResult.localTax | currency: currencySymbol }}</typography>
              </div>
            }
            <!-- County Tax -->
            <div id="invoice_county">
              <typography variant="mat-caption-1" weight="regular" id="countyLabel" class="info-label">{{ appStrings.invoice_county }}</typography>
              <typography variant="mat-body-2" weight="bold" id="countyValue">{{ invoiceFooterResult.gstTax | currency: currencySymbol }}</typography>
            </div>
          </div>
        </div>
        <ds-divider></ds-divider>
      }
      <!-- Totals Subsection -->
      <div id="thirdSubSection" class="second-subSection">
        <div class="subSection-title">
          <typography id="totals" variant="mat-body-1" weight="bold">
            Totals
          </typography>
        </div>
        <div id="firstRowThirdSub" class="header-row">
          <!-- Total Net -->
          <div id="invoice_totalNet">
            <typography variant="mat-caption-1" weight="regular" id="totalNetLabel" class="info-label">{{ appStrings.invoice_totalNet }}</typography>
            <typography variant="mat-body-2" weight="bold" id="totalNetValue">{{ invoiceFooterResult.totalNet | currency: currencySymbol }}</typography>
          </div>
          <!-- Total Shipping & Handling -->
          <div id="invoice_totalShippingHandling">
            <typography variant="mat-caption-1" weight="regular" id="totalShippingHandlingLabel" class="info-label">{{ appStrings.invoice_totalShippingHandling }}</typography>
            <typography variant="mat-body-2" weight="bold" id="totalShippingHandlingValue">{{ invoiceFooterResult.totalShippingAndHandling | currency: currencySymbol }}</typography>
          </div>
        </div>
        <div id="secondRowThirdSub" class="header-row">
          <!-- Total Taxes -->
          <div id="invoice_totalTaxes">
            <typography variant="mat-caption-1" weight="regular" id="totalTaxesLabel" class="info-label">{{ appStrings.invoice_totalTaxes }}</typography>
            <typography variant="mat-body-2" weight="bold" id="totalTaxesValue">{{ invoiceFooterResult.totalTaxes | currency: currencySymbol }}</typography>
          </div>
          <!-- Total Amount -->
          <div id="invoice_totalAmount">
            <typography variant="mat-caption-1" weight="regular" id="totalAmountLabel" class="info-label">{{ appStrings.invoice_totalAmount }}</typography>
            <typography variant="mat-body-2" weight="bold" id="grandTotal">{{ invoiceFooterResult.totalAmount | currency: currencySymbol }}</typography>
          </div>
        </div>
      </div>
    </div>
  }
</div>

